import { render, staticRenderFns } from "./SuppliersHome.vue?vue&type=template&id=b1834796&"
import script from "./SuppliersHome.vue?vue&type=script&lang=js&"
export * from "./SuppliersHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports